var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvas",staticClass:"c-graph c-graph--piechart"},[(_vm.isLoading)?_c('Loading',{attrs:{"transparent":""}}):_vm._e(),_c('svg',{attrs:{"id":"chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }